import React from 'react';
import { Navigate } from 'react-router-dom';
import { sessionManager } from '../config/sessionManager';
import { getFirstAccessibleRoute } from './ProtectedRoute';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticated = sessionManager.isAuthenticated();

  // If user is authenticated, redirect to first accessible route based on permissions
  if (isAuthenticated) {
    const defaultRedirect = getFirstAccessibleRoute();
    return <Navigate to={defaultRedirect} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
